import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import type { ApiQueryParams } from '@/types/apiQuery';
import { DBExportType } from '@/types/export';
import { EndpointResponse } from '@/types/endpoints';
import { utils } from '../../utils';
import type { ReadRequestOptions } from '../requestOptions';

const validate = (exportType: DBExportType) => {
  if (!exportType) {
    throw new Error('`exportType` is required');
  }
};

type RequestParams = Pick<ApiQueryParams, 'limit'> & {
  exportType: DBExportType;
};

type Response = {
  count: number;
};

export const getExportProfilesCount = async (
  scope: RequestScope,
  { exportType, limit = 1000 }: RequestParams,
  options: ReadRequestOptions
): Promise<EndpointResponse<Response>> => {
  try {
    validate(exportType);

    const result = await scopedApi(scope).get<EndpointResponse<Response>>(
      `export_profile/count?limit=${limit}&query={"export_type": "${exportType}"}`,
      options
    );
    return result.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
